import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { UiScrollModule } from "ngx-ui-scroll";
import { GadgetModule } from "../gadget/gadget.module";
import { QuickJoinLabComponent } from "./quick-join-lab.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MaterialModule,
        SharedModule,
        UiScrollModule,
        GadgetModule
    ],
    declarations: [QuickJoinLabComponent],
    exports: [QuickJoinLabComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
    
})
export class QuickJoinLabModule {}